var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1781060767146,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1533,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M727.48 818.31l-49.44 4c-48.56 3.88-117.24 5.82-165.93 5.83-49 0-117.95-1.93-166.81-5.83l-49.43-4a187.58 187.58 0 0 1-172-172l-4.32-54.07c-3.6-45-3.6-118.51 0-163.46l4.32-54.08a187.58 187.58 0 0 1 172-172l49.43-4c48.72-3.89 117.54-5.84 166.37-5.84s117.66 2 166.37 5.84l49.44 4a187.58 187.58 0 0 1 172 172l4 49.44c3.89 48.71 4.14 145.5 0 172.74l-4 49.43a187.58 187.58 0 0 1-172 172z",
    fill: "#A3A5AF",
    "p-id": 1534
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M600.51 539.63c-41.68 20-69.55 54.39-69.55 94 0 62 67.81 70.71 151.47 70.71s151.47-8.66 151.47-70.71c0-39.56-27.87-74-69.55-94 0 0-31.74-17.24-82.3-17.24-53.96 0-81.54 17.24-81.54 17.24z",
    fill: "#333333",
    "p-id": 1535
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M591.59 447.99a90.84 101.99 0 1 0 181.68 0 90.84 101.99 0 1 0-181.68 0Z",
    fill: "#333333",
    "p-id": 1536
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M461 465.54H269.69a30 30 0 0 1 0-60H461a30 30 0 0 1 0 60zM417 610.54H269.69a30 30 0 0 1 0-60H417a30 30 0 0 1 0 60z",
    fill: "#333333",
    "p-id": 1537
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRound);
export default __webpack_public_path__ + "static/media/user-round.6bb0fd643cf12a2b97045cd4dfb7edd0.svg";
export { ForwardRef as ReactComponent };